module.exports = __webpack_public_path__ + "img/default_av.fe5ab908.png";